<template>
  <!-- Welcome Drip Dashboard -->
  <div class="content-wrapper">
    <!-- AsideBar -->
    <AsideBar />
    <!-- Content Header -->
    <div class="content-header">
      <div
        style="
          border-bottom: 1px solid #5c4a4a17;
          margin: auto !important;
          height: 75px;
        "
      >
        <div class="row mb-2">
          <div class="col-sm-12 d-flex flex-column align-items-baseline">
            <h1 class="m-0 text-dark">Triggered Notifications</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Dashboard' }"
                >Dashboard</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'MainCont' }"
                >Website Dashboard</router-link
              >
              <li class="breadcrumb-item active">Triggered Notifications</li>
            </ol>
            <div class="button-group">
              <router-link
                tag="button"
                :to="{ name: 'TriggerCreator' }"
                class="btn btn-color--primary ml-3 mt-8 mb-1"
                style="border-radius: unset; background: #007bff"
              >
                <svg
                  width="14"
                  height="17"
                  viewBox="0 0 14 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00016 16.3333C7.91683 16.3333 8.66683 15.5833 8.66683 14.6667H5.3335C5.3335 15.5833 6.07516 16.3333 7.00016 16.3333ZM12.0002 11.3333V7.16667C12.0002 4.60834 10.6335 2.46667 8.25016 1.9V1.33334C8.25016 0.641669 7.69183 0.0833359 7.00016 0.0833359C6.3085 0.0833359 5.75016 0.641669 5.75016 1.33334V1.9C3.3585 2.46667 2.00016 4.6 2.00016 7.16667V11.3333L0.333496 13V13.8333H13.6668V13L12.0002 11.3333Z"
                    fill="white"
                  />
                </svg>
                Create Trigger Notification
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <section class="mt-3 pb-12">
      <!-- <div class="container" style="margin: 0 auto !important">
        <div class="row d-flex justify-content-center">
          <div class="col-12 pt-4"> -->
      <v-card>
        <v-card-title class="table-card-header--color height-70 pl-0">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            class="table-search-field--width ml-2"
            solo
            dense
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="notifications"
          :search="search"
          :loading="loading"
          :footer-props="{
            'items-per-page-options': [10, 25, 50],
          }"
          calculate-widths
          loading-text="Loading Triggered Notifications ..."
          no-data-text="No Triggered Notification created."
          class="elevation-1"
        >
          <!-- Buttons -->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex flex-row justify-content-center w-100">
              <v-btn
                dark
                small
                color="success"
                @click="
                  shwCode = true;
                  event = item.event;
                "
              >
                Code
              </v-btn>
              <router-link
                tag="button"
                :to="{
                  name: 'TriggerEdit',
                  params: { trigger_id: item.id },
                }"
                class="mx-2"
              >
                <v-btn dark small color="#FFCA28">
                  <v-icon dark small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </router-link>
              <v-btn
                dark
                small
                color="error"
                @click="
                  selectedId = item.id;
                  shwQuestion = true;
                "
              >
                <v-icon dark small>
                  mdi-trash-can-outline
                </v-icon>
              </v-btn>
            </div>
          </template>
          <!-- Switch Template -->
          <template v-slot:[`item.is_active`]="{ item }">
            <v-switch
              v-model="item.is_active"
              :value="item.is_active"
              @change="changeStatus(item)"
              class="m-0"
              hide-details
            ></v-switch>
          </template>
        </v-data-table>
      </v-card>
      <!-- </div>
        </div> -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <div class="overlay" v-if="shwCode">
          <div
            class="position-absolute code-block center py-15 px-6"
            style="background: #fff"
          >
            <span class="cross" @click="shwCode = !shwCode">&times;</span>
            <div class="py-6 px-6 mt-4" style="background: #cbdff1">
              <span>
                <span>handleTriggerPushEvent('{{ this.event }}');</span>
              </span>
            </div>
            <button
              class="btn btn-success position-absolute mt-2 m-0"
              @click="copyCode"
            >
              Copy Code
            </button>
          </div>
        </div>
      </transition>
      <!-- </div> -->
    </section>
    <!-- Error PopUp -->
    <Error v-if="error" :error="error" />
    <!-- <Warnings
      v-if="warningPopUp && !selectedDrips.length"
      @didClose="warningPopUp = false"
      warningText="Select drips!"
    /> -->
    <Question
      v-if="shwQuestion"
      @confirmed="deleteTrigger(selectedId)"
      @notConfirmed="shwQuestion = false"
      @didClose="shwQuestion = false"
      title="Are you sure?"
      text="You wiil delete this triggered notification and won't be able to restore it."
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
      isConfirmedTitle="Deleted"
      isConfirmedText="Triggered notification has been deleted!"
      dismissTitle="Cancelled"
      dismissText="Triggered notification is in safe :)"
      confirmButtonClasses="btn btn-danger"
      cancelButtonClasses="btn btn-success"
      successIcon="success"
      errorIcon="error"
    />
  </div>
</template>

<script>
//import "../../../assets/styles/main.css";
import "animate.css";
import { mapState, mapActions } from "vuex";
import Question from "../../popUps/Question.vue";
import AsideBar from "../../websiteDash/AsideBar.vue";
import Warnings from "../../popUps/Warnings.vue";
import Error from "../../popUps/Error.vue";

export default {
  name: "TriggeredNotifications",
  components: {
    AsideBar,
    Question,
    Error,
    Warnings,
  },
  data() {
    return {
      event: "",
      loading: true,
      selectedId: "",
      shwQuestion: false,
      shwCode: false,
      search: "",
      headers: [
        {
          text: "Id",
          value: "id",
          align: "left",
          sortable: true,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Name",
          value: "event",
          align: "left",
          sortable: true,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Status",
          value: "is_active",
          sortable: false,
          divider: true,
          align: "center",
          class:
            "table-header--color d-flex align-items-center justify-content-center",
        },
        {
          text: "Created at",
          value: "created_at",
          sortable: true,
          divider: true,
          class: "table-header--color",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      notifications: (state) => state.triggers.notifications,
      error: (state) => state.triggers.errorTrigger,
    }),
  },
  mounted() {
    this.getTriggers(
      `?where[domain_id]=${this.$route.params.id}&order_by=id:desc`
    )
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

    // window.addEventListener("popstate", () => {
    //   this.clearTriggersArray();
    // });
  },
  // beforeDestroy() {
  //   window.removeEventListener("popstate", () => {
  //     this.clearTriggersArray();
  //   });
  // },
  methods: {
    ...mapActions([
      "getTriggers",
      "updateTrigger",
      "deleteTrigger",
      "clearTriggersArray",
    ]),
    /**
     * Change status.
     * @param {object} item - The trigger notification object.
     */
    changeStatus(item) {
      item.is_active ? (item.is_active = 1) : (item.is_active = 0);
      this.updateTrigger({ id: item.id, json: item });
    },
    /**
     * Copy code.
     */
    copyCode() {
      const selection = window.getSelection();
      const range = document.createRange();

      range.selectNodeContents(document.querySelector(".py-6.px-6"));

      selection.removeAllRanges();
      selection.addRange(range);

      document.execCommand("copy");
    },
  },
  watch: {
    "$route.name": {
      handler: "clearTriggersArray",
      immediate: true,
    },
  },
};
</script>

<style>
.center {
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.code-block {
  width: fit-content;
  height: fit-content;
  background: #fff;
  z-index: 99999;
}
.code-block .cross {
  cursor: pointer;
  right: 10px;
  top: 2px;
}
.code-block .btn {
  right: 24px;
  border-radius: 0px !important;
}
.code-block span.text-left {
  top: 14px;
  font-size: 23px;
}
@media (max-width: 300px) {
  .bi-justify {
    margin-left: -13px;
  }
}
</style>
